module.exports = __webpack_public_path__ + "img/lock_w.1a538f65.svg";